mutation UpdateAgentStatus($input: AgentStatusUpdateInput!) {
    chatAgentStatusUpdate(input: $input) {
        id
        agentStatus
    }
}
